import React from "react";
import { Bot, Check, Clock, MessageCircle } from "lucide-react";

// AgentFlow — WhatsApp + performance mockup
export const AgentFlowMockup = () => {
  return (
    <div
      className="relative w-full h-full rounded-2xl border border-sand-soft overflow-hidden bg-[#0E0E10]"
    >
      <div
        aria-hidden
        className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(closest-side, rgba(212,111,77,0.18), rgba(212,111,77,0) 70%)",
        }}
      />

      <div className="relative p-6 md:p-7 h-full flex flex-col">
        {/* Top bar */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Bot size={14} className="text-terracotta" />
            <span className="font-display text-sm text-maif">AgentFlow</span>
            <span className="eyebrow text-[9px] text-maif-muted">· Performance</span>
          </div>
          <span className="inline-flex items-center gap-1.5 text-[10px] text-emerald-300">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" />
            Live on WhatsApp
          </span>
        </div>

        {/* Hero metric */}
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          <div className="rounded-lg bg-white/[0.04] p-4">
            <div className="text-[9px] tracking-[0.2em] uppercase font-semibold text-sand">Hours saved · this week</div>
            <div className="mt-1 font-display font-light text-3xl md:text-4xl text-terracotta tracking-tighter">
              20+ h
            </div>
          </div>
          <div className="rounded-lg bg-white/[0.04] p-4">
            <div className="text-[9px] tracking-[0.2em] uppercase font-semibold text-sand">Resolved without humans</div>
            <div className="mt-1 font-display font-light text-3xl md:text-4xl text-maif tracking-tighter">
              70%
            </div>
          </div>
        </div>

        {/* WhatsApp message thread */}
        <div className="mt-5 flex-1 rounded-lg bg-white/[0.03] p-3 space-y-2 overflow-hidden">
          <div className="flex items-center gap-2 pb-2 border-b border-sand-soft/50">
            <MessageCircle size={11} className="text-emerald-400" />
            <span className="text-[10px] text-maif-muted">
              WhatsApp · Atlas Commerce
            </span>
          </div>

          {/* Customer */}
          <div className="flex justify-start">
            <div className="max-w-[80%] rounded-lg rounded-bl-none bg-white/[0.05] px-3 py-1.5 text-[11px] text-maif">
              Salam, où est ma commande #4821 ?
            </div>
          </div>

          {/* Agent reply */}
          <div className="flex justify-end">
            <div className="max-w-[80%] rounded-lg rounded-br-none bg-terracotta/15 border border-terracotta/30 px-3 py-1.5 text-[11px] text-maif">
              Bonjour 👋 Votre commande est en transit, livraison prévue demain entre 10h et 14h. Lien de suivi : maif.ma/t/4821
            </div>
          </div>

          {/* Customer follow-up */}
          <div className="flex justify-start">
            <div className="max-w-[80%] rounded-lg rounded-bl-none bg-white/[0.05] px-3 py-1.5 text-[11px] text-maif">
              Merci !
            </div>
          </div>

          {/* Auto-resolved */}
          <div className="flex items-center gap-1.5 text-[9px] text-emerald-300/80 pt-1">
            <Check size={10} />
            Auto-resolved · 1.4s response · no human needed
          </div>
        </div>

        {/* Footer chips */}
        <div className="mt-5 flex items-center gap-2 flex-wrap">
          <span className="inline-flex items-center gap-1 rounded-full border border-sand-soft bg-white/[0.02] px-2 py-0.5 text-[10px] text-maif-muted">
            <Clock size={10} /> Avg 1.4s
          </span>
          <span className="inline-flex items-center gap-1 rounded-full border border-sand-soft bg-white/[0.02] px-2 py-0.5 text-[10px] text-maif-muted">
            CRM · WhatsApp · Email
          </span>
          <span className="inline-flex items-center gap-1 rounded-full border border-sand-soft bg-white/[0.02] px-2 py-0.5 text-[10px] text-maif-muted">
            EN · FR · AR
          </span>
        </div>
      </div>
    </div>
  );
};

export default AgentFlowMockup;
